import api from "../api";
import { plausibleEvent } from "./track";

export const startCheckout = async (packageId, extra = {}) => {
  const { data } = await api.post("/payments/checkout", {
    package_id: packageId,
    origin_url: window.location.origin,
    ...extra,
  });
  plausibleEvent("Upgrade Started", { package: packageId });
  // A 100%-off code is granted server-side, so there is nothing to pay for and no redirect.
  if (data.free) { plausibleEvent("Purchase", { package: packageId, free: true }); window.location.reload(); return data; }
  window.location.href = data.checkout_url;
  return data;
};

export const planTier = (user) => {
  if (!user) return "free";
  const plan = user.plan === "business_plus" || user.plan === "pro" ? user.plan : "free";
  if (plan === "free") return "free";
  if (user.planLifetime) return plan;
  return user.planExpiresAt && new Date(user.planExpiresAt) > new Date() ? plan : "free";
};

export const isProActive = (user) => planTier(user) !== "free";

export const isBusinessPlus = (user) => planTier(user) === "business_plus";
